/* psb-b06 — ficha Box 0-6 (v6). JS propio: no usa los custom elements del tema. */
(() => {
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const quieto = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const datos = $('[data-psb-variantes]');
  if (!datos) return;
  const V = JSON.parse(datos.textContent);
  const idIni = ($('[data-psb-id]') || {}).value;
  let actual = V.find((v) => String(v.id) === String(idIni)) || V[0];

  /* galería: una pista por versión; foto al 100 % del marco, miniaturas siempre visibles */
  const sets = $$('.psb-gal__set').map((set) => {
    const pista = $('.psb-gal__pista', set);
    const fotos = $$('.psb-gal__foto', pista);
    const minis = $$('[data-psb-thumb]', set);
    const tira = $('.psb-gal__minis', set);
    const cont = $('[data-psb-cont]', set);
    const prev = $('[data-psb-prev]', set);
    const next = $('[data-psb-next]', set);
    const paso = () => (fotos[1] ? fotos[1].offsetLeft - fotos[0].offsetLeft : 1) || 1;
    const idx = () => Math.max(0, Math.min(fotos.length - 1, Math.round(pista.scrollLeft / paso())));
    const pintar = () => {
      const i = idx();
      minis.forEach((d, k) => d.setAttribute('aria-current', String(k === i)));
      const m = minis[i];
      if (m && tira && tira.scrollWidth > tira.clientWidth) {
        const izq = m.offsetLeft - tira.offsetLeft;
        if (izq < tira.scrollLeft || izq + m.offsetWidth > tira.scrollLeft + tira.clientWidth) {
          tira.scrollLeft = izq - (tira.clientWidth - m.offsetWidth) / 2;
        }
      }
      if (cont) cont.textContent = (i + 1) + ' / ' + fotos.length;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === fotos.length - 1;
    };
    const ir = (i) => {
      i = Math.max(0, Math.min(fotos.length - 1, i));
      pista.scrollTo({ left: i * paso(), behavior: quieto ? 'auto' : 'smooth' });
    };
    let raf = 0;
    let fin = 0;
    pista.addEventListener('scroll', () => {
      cancelAnimationFrame(raf); raf = requestAnimationFrame(pintar);
      clearTimeout(fin); fin = setTimeout(pintar, 120);
    }, { passive: true });
    pista.addEventListener('scrollend', pintar);
    if (prev) prev.addEventListener('click', () => ir(idx() - 1));
    if (next) next.addEventListener('click', () => ir(idx() + 1));
    minis.forEach((m, k) => m.addEventListener('click', () => ir(k)));
    pista.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); ir(idx() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); ir(idx() - 1); }
    });
    return { set, reiniciar: () => { pista.scrollLeft = 0; if (tira) tira.scrollLeft = 0; pintar(); } };
  });

  /* versión */
  const aplicar = (v, sinUrl) => {
    actual = v;
    $$('[data-psb-v]').forEach((el) => { el.hidden = el.dataset.psbV !== v.s; });
    $$('[data-psb-id]').forEach((i) => { i.value = v.id; });
    $$('[data-psb-elegir]').forEach((b) => {
      const on = b.dataset.psbElegir === String(v.id);
      b.setAttribute('aria-pressed', String(on));
      b.classList.toggle('on', on);
    });
    $$('[data-psb-comprar]').forEach((b) => {
      b.disabled = !v.a;
      const t = $('[data-psb-txt]', b);
      if (t && b.dataset.txtOk) t.textContent = v.a ? b.dataset.txtOk : b.dataset.txtNo;
    });
    sets.forEach((s) => s.reiniciar());
    if (!sinUrl) {
      try {
        const u = new URL(location.href);
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u.toString());
      } catch (e) { /* srcdoc o URL no editable */ }
    }
  };
  $$('[data-psb-elegir]').forEach((b) => b.addEventListener('click', () => {
    const v = V.find((x) => String(x.id) === b.dataset.psbElegir);
    if (v && v !== actual) aplicar(v);
  }));
  window.psbB06Aplicar = (v) => aplicar(Object.assign({}, actual, v), true);
  window.psbB06Actual = () => Object.assign({}, actual);

  /* cantidad: la del formulario de Agregar se copia al de Comprar pack estimulante */
  const cant = $('[data-psb-cant]');
  const sync = () => {
    const n = Math.max(1, parseInt(cant.value, 10) || 1);
    cant.value = n;
    $$('[data-psb-cant-pago]').forEach((i) => { i.value = n; });
  };
  if (cant) {
    cant.addEventListener('change', sync);
    cant.addEventListener('input', () => { if (cant.value !== '') sync(); });
    const menos = $('[data-psb-menos]');
    const mas = $('[data-psb-mas]');
    if (menos) menos.addEventListener('click', () => { cant.value = (parseInt(cant.value, 10) || 1) - 1; sync(); });
    if (mas) mas.addEventListener('click', () => { cant.value = (parseInt(cant.value, 10) || 1) + 1; sync(); });
  }

  /* línea de envío (LINEA-ENVIO ronda 7). Hora de Santiago, no la del aparato. BabyFlash: corte 15:00 lun-sáb, 13:00 dom, sin festivos.
     Sin JS, o en un año que no está en la lista, queda el texto del HTML. Forzar un caso: #t=2026-10-13T16:00
     Festivos: feriados.cl, nacionales 2026 y 2027 (abierta el 11-10-2026). Al terminar 2027 se suman los de 2028. */
  const FEST = ['2026-01-01', '2026-04-03', '2026-04-04', '2026-05-01', '2026-05-21', '2026-06-21', '2026-06-29', '2026-07-16', '2026-08-15', '2026-09-18', '2026-09-19', '2026-10-12', '2026-10-31', '2026-11-01', '2026-12-08', '2026-12-25',
    '2027-01-01', '2027-03-26', '2027-03-27', '2027-05-01', '2027-05-21', '2027-06-21', '2027-06-28', '2027-07-16', '2027-08-15', '2027-09-17', '2027-09-18', '2027-09-19', '2027-10-11', '2027-10-31', '2027-11-01', '2027-12-08', '2027-12-25'];
  const T = { hoy: 'Si compras antes de las 15:00 llega hoy en Santiago', hoydom: 'Si compras antes de las 13:00 llega hoy en Santiago', man: 'Si compras ahora llega mañana en Santiago', mandom: 'Si compras ahora llega el domingo en Santiago', festhoy: 'Hoy es festivo: llega mañana en Santiago', visp: 'Mañana es festivo: llega el {dia} en Santiago' };
  const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const lineas = $$('[data-envio]');
  lineas.forEach((e) => { e.dataset.sinjs = e.textContent; });
  const envio = () => {
    let y, m, d, h;
    const f = /#t=(\d{4})-(\d\d)-(\d\d)T(\d\d):(\d\d)/.exec(location.hash);
    if (f) { y = +f[1]; m = +f[2]; d = +f[3]; h = +f[4]; } else {
      const p = {};
      new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Santiago', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
        .formatToParts(new Date()).forEach((x) => { p[x.type] = x.value; });
      y = +p.year; m = +p.month; d = +p.day; h = +p.hour;
    }
    const dia = (n) => new Date(Date.UTC(y, m - 1, d + n));
    const iso = (t) => t.toISOString().slice(0, 10);
    const cubre = (t) => { const a = iso(t).slice(0, 4); return FEST.some((s) => s.slice(0, 4) === a); };
    const fest = (t) => FEST.indexOf(iso(t)) >= 0;
    const hoy = dia(0);
    let t = null;
    let n = 1;
    if (cubre(hoy)) {
      const corte = hoy.getUTCDay() === 0 ? 13 : 15;
      if (!fest(hoy) && h < corte) t = corte === 13 ? T.hoydom : T.hoy;
      else {
        while (n < 8 && cubre(dia(n)) && fest(dia(n))) n++;
        if (n < 8 && cubre(dia(n))) {
          const N = dia(n);
          if (n === 1) t = fest(hoy) ? T.festhoy : (N.getUTCDay() === 0 ? T.mandom : T.man);
          else t = T.visp.replace('{dia}', DIAS[N.getUTCDay()]);
        }
      }
    }
    lineas.forEach((e) => { e.textContent = t || e.dataset.sinjs; });
    return t;
  };
  window.psbB06Envio = envio;
  try { envio(); } catch (e) { /* queda el texto sin JS */ }
  window.addEventListener('hashchange', () => { try { envio(); } catch (e) { /* idem */ } });
  /* «ver Envíos» abre el desplegable */
  $$('[data-psb-ver-envios]').forEach((a) => a.addEventListener('click', () => {
    const d = document.getElementById('envios');
    if (d) d.open = true;
  }));

  /* tira: puntos que siguen a la tarjeta visible */
  $$('[data-psb-tira]').forEach((tira) => {
    const carril = $('.psb-tira__carril', tira);
    const ts = $$('.psb-tira__t', carril).filter((t) => !t.hidden);
    const pts = $$('.psb-tira__puntos span', tira);
    const pintar = () => {
      const vis = $$('.psb-tira__t', carril).filter((t) => t.offsetParent !== null);
      const p = vis[1] ? vis[1].offsetLeft - vis[0].offsetLeft : 1;
      const max = carril.scrollWidth - carril.clientWidth;
      const i = carril.scrollLeft >= max - 2 ? vis.length - 1 : Math.round(carril.scrollLeft / (p || 1));
      pts.forEach((s, k) => s.setAttribute('aria-current', String(k === i)));
    };
    let raf = 0;
    carril.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(pintar); }, { passive: true });
    if (ts.length) pintar();
  });

  /* reseñas (Revie): «Leer más» en las que pasan de 4 líneas; si el widget no carga, la caja se oculta y no deja hueco */
  const res = $('.psb-res');
  if (res) {
    const masTxt = 'Leer más';
    const menosTxt = 'Leer menos';
    const revisar = () => {
      $$('.rvp-row', res).forEach((r) => {
        const t = $('.rvp-text', r);
        if (!t || r.dataset.psbMas) return;
        if (t.scrollHeight - t.clientHeight > 2) {
          r.dataset.psbMas = '1';
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'psb-res__mas';
          b.textContent = masTxt;
          b.setAttribute('aria-expanded', 'false');
          b.addEventListener('click', () => {
            const ab = r.classList.toggle('psb-abierta');
            b.textContent = ab ? menosTxt : masTxt;
            b.setAttribute('aria-expanded', String(ab));
          });
          t.after(b);
        }
      });
    };
    const lista = () => $('.rvp-row', res);
    if ('MutationObserver' in window) new MutationObserver(() => { if (lista()) revisar(); }).observe(res, { childList: true, subtree: true });
    const cerrar = () => { if (!lista()) res.classList.add('psb-res--sin'); else revisar(); };
    if (document.readyState === 'complete') setTimeout(cerrar, 6000); else window.addEventListener('load', () => setTimeout(cerrar, 6000));
    revisar();
  }

  /* barra fija y botón de chat (a.wsp, del layout): el chat se esconde mientras se vea el bloque de compra (≤999 px)
     y, con la barra, sube por encima de ella (las reglas viven en el <style> de la sección) */
  const raiz = document.body;
  const barra = $('[data-psb-barra]');
  const botones = $('[data-psb-botones]');
  if (barra && botones && 'IntersectionObserver' in window) {
    new IntersectionObserver(([e]) => {
      const on = !e.isIntersecting && e.boundingClientRect.top < 0;
      barra.classList.toggle('is-on', on);
      barra.setAttribute('aria-hidden', String(!on));
      raiz.classList.toggle('psb-barra-on', on);
    }).observe(botones);
  }
  const compra = $('[data-psb-compra]');
  if (compra && 'IntersectionObserver' in window) {
    const movil = matchMedia('(max-width: 999px)');
    let ve = false;
    const pon = () => raiz.classList.toggle('psb-wsp-off', ve && movil.matches);
    new IntersectionObserver(([e]) => { ve = e.isIntersecting; pon(); }).observe(compra);
    if (movil.addEventListener) movil.addEventListener('change', pon);
  }
})();
